import { useStores } from '@littlebird/sdk';
import { useEffect } from 'react';

export const useLoadRoutineRuns = (routineId: number) => {
  const { reports } = useStores();

  useEffect(() => {
    reports.loadRoutineRuns(routineId).catch(() => undefined);
  }, [reports, routineId]);
};
